import * as React from "react";
import {connect} from "react-redux";
import Lead from "../../../model/lead/Lead";
import {option, Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import {editLead} from "../../../store/action/lead/lead";
import {Dispatch} from "redux";
import Toast from "../../helper/Toast";
import AcquisitionChannel from "../../../model/acquisitionChannel/AcquisitionChannel";
import AcquisitionChannelDropdown from "./AcquisitionChannelDropdown";

interface ComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface ReduxProps {
	/**
	 * Lead acquisition channels.
	 */
	acquisitionChannels: AcquisitionChannel[]
}

interface DispatchProps {
	/**
	 * Edit lead action.
	 * @param {Lead} lead
	 */
	editLead: (lead: Lead) => void;
}

type Props = ComponentProps & ReduxProps & DispatchProps

class LeadAcquisitionChannelDropdown extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		const selectedAcquisitionChannelId = this.props.lead.flatMap(l => l.data.acquisitionChannelId).orNull;
		return (
			<AcquisitionChannelDropdown acquisitionChannels={this.props.acquisitionChannels}
										selectedAcquisitionChannelId={this.props.lead.flatMap(l => l.data.acquisitionChannelId)}
										onChange={this.onSelect}/>
		);
	}

	onSelect(item: AcquisitionChannel) {
		this.props.lead.map(l => {
			const updatedLead = l.copy({data: l.data.copy({acquisitionChannelId: option(item.id)})});
			this.props.editLead(updatedLead);
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead) => dispatch(
			editLead(
				lead,
				() => Toast.success("Lead acquisition channel updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		acquisitionChannels: state.acquisitionChannel.acquisitionChannels.getOrElse([])
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadAcquisitionChannelDropdown)